// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button__KkRtb{margin-bottom:1rem}`, "",{"version":3,"sources":["webpack://./src/components/PassKey/PassKey.module.scss"],"names":[],"mappings":"AAAA,eACI,kBAAA","sourcesContent":[".button {\n    margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button__KkRtb`
};
export default ___CSS_LOADER_EXPORT___;
